import { ActionIcon, Box, Menu } from '@mantine/core';
import {
  IconArchive,
  IconArchiveOff,
  IconDotsVertical,
  IconEye,
  IconTrash,
} from '@tabler/icons-react';
import { CompanyDocument } from '../../types';

interface AppendixRowActionsProps {
  document: CompanyDocument;
  onView: (doc: CompanyDocument) => void;
  onArchive: (doc: CompanyDocument) => void;
  onUnarchive: (doc: CompanyDocument) => void;
  onDelete: (doc: CompanyDocument) => void;
  isUpdating: boolean;
}

export default function AppendixRowActions({
  document,
  onView,
  onArchive,
  onUnarchive,
  onDelete,
  isUpdating,
}: AppendixRowActionsProps) {
  return (
    <Box ta="right">
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray">
            <IconDotsVertical size={16} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconEye size={14} />} onClick={() => onView(document)}>
            View
          </Menu.Item>
          <Menu.Divider />
          {document.isArchived ? (
            <>
              <Menu.Item
                leftSection={<IconArchiveOff size={14} />}
                onClick={() => onUnarchive(document)}
                disabled={isUpdating}
              >
                Unarchive
              </Menu.Item>
              <Menu.Item
                leftSection={<IconTrash size={14} />}
                color="red"
                onClick={() => onDelete(document)}
              >
                Delete
              </Menu.Item>
            </>
          ) : (
            <Menu.Item leftSection={<IconArchive size={14} />} onClick={() => onArchive(document)}>
              Archive
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
}
